import { API_URL } from '../../config/api';

/**
 * Resolve a report media URL for display. Pantry/photo assets are served by the
 * backend's `/api/photo-upload/serve/...` route (which presign-redirects to S3),
 * stored as a RELATIVE path so it works in every environment. The report is
 * hosted on the frontend origin, so a relative `/api/...` would hit the frontend
 * — prepend the API base for those. Absolute URLs (http/https, data:) pass
 * through unchanged.
 */
export function mediaSrc(url: string): string {
  if (!url) return url;
  if (/^(https?:|data:)/.test(url)) return url;
  const base = (API_URL || '').replace(/\/$/, '');
  return `${base}${url.startsWith('/') ? '' : '/'}${url}`;
}
